import React from 'react';

import { IconPropsType } from 'designSystem/types/icons';

interface IGiftStrokeIconProps extends IconPropsType {}

const GiftStrokeIcon = ({
  size = 16,
  stroke = '#ffffff',
  ...props
}: IGiftStrokeIconProps) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M8 5.16634V4.05523M8 5.16634H6.88889C5.66159 5.16634 4.66667 4.17142 4.66667 2.94412C4.66667 2.33047 5.16413 1.83301 5.77778 1.83301C7.00508 1.83301 8 2.82793 8 4.05523M8 5.16634H9.11111C10.3384 5.16634 11.3333 4.17142 11.3333 2.94412C11.3333 2.33047 10.8359 1.83301 10.2222 1.83301C8.99492 1.83301 8 2.82793 8 4.05523M8 5.16634V13.4997M3.16667 7.99967V13.4997H12.8333V7.99967M3.16667 7.99967H12.8333M3.16667 7.99967H2.5V5.16634H13.5V7.99967H12.8333"
      stroke={stroke}
    />
  </svg>
);

export default GiftStrokeIcon;
